<div class="project">
  <div class="doku">
    <mat-icon class="icon">stacks</mat-icon>
    <div class="entry">
      <div class="bigtext">{{ project().text }}</div>
      @if (showDescription()) {
        <div class="text mat-small">{{ project().shortDescription }}</div>
      }
    </div>
  </div>
</div>
